import { boolHttp, http } from './http';
import { LoginUrl, LogoutUrl, VerifyLoginUrl } from './urls';

const AuthService = {
  login: async (username: string, password: string): Promise<boolean> => {
    const req = new Request(LoginUrl(), {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });
    return await boolHttp(req);
  },

  logout: async (): Promise<void> => {
    const req = new Request(LogoutUrl(), { method: 'POST' });
    return await http<void>(req);
  },

  verify: async (): Promise<boolean> => {
    const req = new Request(VerifyLoginUrl(), { method: 'POST' });
    return await boolHttp(req).then();
  },
};

export default AuthService;
